
import {initWebComponent} from "@/helpers/web-component-helper";
import toastr from "toastr"
import {
    getAttributeItemByFeatureInfo,
    getFeatureInfoByFeatureInfoKey
} from "@/helpers/plugin-helper";
import $ from "jquery";
import FileSaver from "file-saver";
import {showNotification} from "@/helpers/notification-helper";
import {generateGeoJsonObjectFromFeature} from "@/helpers/ol/ol-geo-json-helper";
import {getBookmarkPresentationsByID, getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {startLadda, startLaddaByElement, stopLadda} from "@/helpers/ladda-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import {wordAddRectangle} from "@/helpers/word/word-helper";
import {Point, Polygon} from "ol/geom";
export class LayerInfoInfoPluginWordComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const mainTabIndex = this.getAttribute('data-main-tab-index')
        const featureKey = this.getAttribute('data-feature-key')

        const feature = window.mainTabs[mainTabIndex].features[featureKey]
        const featureInfo = getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey)

        const domainID = featureInfo.DomainID
        const presentationID = featureInfo.PresentationID

        const record = featureInfo.records[0]

        const attribute = record.attributes[0][0]
        let imageHeight = attribute.ImageHeight
        let imageWidth = attribute.ImageWidth
        let linkedAttributeID = attribute.LinkedAttributeID

        console.log(attribute.ActionAdvancedFourth)

        if(!attribute.ActionAdvancedFourth) {
            imageHeight = 0
            imageWidth = 0
        }

        let innerHTML = '<div class="p-2">'

        let createClass = ''

        console.log(imageHeight)

        if(imageHeight > 0) {
            innerHTML +=  `
               <button id="btnPrintCreateWordPosition" data-spinner-color="#858380" class="btn btn-block btn-outline-secondary ladda-button">Positioneer kaart</button>
        `;
            createClass = 'd-none'
        }

        let formSubTypeText = 'word'
        let extension = 'docx'
        if(featureInfo.FormSubTypeID === 1) {
            formSubTypeText = 'pdf'
            extension = 'pdf'
        }

        innerHTML +=  `
               <button id="btnPrintCreateWord" data-spinner-color="#858380" class="btn btn-block btn-outline-secondary ladda-button ${createClass}">Maak ${formSubTypeText} document</button>
        </div>
        `;

        template.innerHTML = innerHTML

        initWebComponent(this, template)

        let coordinates = record.geometry.coordinates
        if(!record.geometry) {

            let geometry = feature.feature.geometry
            if(geometry.type === 'Polygon') {
                coordinates = new Polygon(feature.feature.geometry.coordinates)
                coordinates = coordinates.getInteriorPoint().getCoordinates()
            } else {
                coordinates = feature.feature.geometry.coordinates
            }
        }

        if(!coordinates) {
            coordinates = [window.lastClickedData.data.x, window.lastClickedData.data.y]
        }

        console.log(record)
        console.log(feature)
        console.log(featureInfo)

        const features = generateGeoJsonObjectFromFeature(feature.feature, false)

        let geometry = features[0].getGeometry()

        if(!geometry) {
            geometry = new Point(coordinates)
        }

        const featureID = record.featureid
        let fileName = featureID
        if(linkedAttributeID) {
            record.attributes.map((attributeItem) => {
                attributeItem.map((item) => {
                    if(item.ID === linkedAttributeID) {
                        fileName = item.Value
                    }
                })
            })
        }

        // console.log(record)
        // console.log(feature)
        // console.log(features)
        // console.log(linkedAttributeID)

        const x = coordinates[0]
        const y = coordinates[1]

        let bookmarkPresentations = '['
        window.layersActive.map((layerActive) => {
            const bookmarkPresentationActive = getBookmarkPresentationsByID(layerActive)

            console.log(bookmarkPresentationActive)

            if(bookmarkPresentationActive) {
                bookmarkPresentations += `[${bookmarkPresentationActive.DomainID}, ${bookmarkPresentationActive.PresentationID}, ${bookmarkPresentationActive.ID}],`
            }
        })
        bookmarkPresentations += ']'
        const geometryType = 'undefined'

        const btnPrintCreateWord = this.querySelector('#btnPrintCreateWord')

        if(imageHeight > 0) {
            this.querySelector('#btnPrintCreateWordPosition').addEventListener('click', () => {

                if (features.length > 0) {
                    wordAddRectangle(geometry, imageWidth, imageHeight)
                }

                btnPrintCreateWord.classList.remove('d-none')
            })
        }

        btnPrintCreateWord.addEventListener('click', () => {
            startLaddaByElement(btnPrintCreateWord)

            let bbox = ''
            if(features.length > 0 && imageHeight > 0) {
                bbox = getLayerByName('wordPrint', false).getSource().getFeatures()[0].getGeometry().getExtent().join(',')
                // bbox =
            }

            let url_report = window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + domainID + '/presentation/' + presentationID + '/report/' + featureInfo.FormID + '/' + fileName + `.${extension}?featureIds=` + featureID +
                '&x=' + x +
                '&y=' + y +
                '&bbox=' + bbox +
                '&bookmarkPresentations=' + bookmarkPresentations +
                '&geometryType=' + geometryType

            showNotification('Document wordt aangemaakt');
            $.ajax({
                type: "GET",
                url: url_report,
                cache: false,
                dataType: 'binary',
                xhrFields: {
                    responseType: 'arraybuffer'
                },
                beforeSend: function (xhr, settings) {
                    xhr.setRequestHeader ("Authorization", getToken());

                    if (settings.dataType === 'binary') {
                        settings.xhr().responseType = 'arraybuffer';
                    }
                },
                success: function (data, status, headers) {
                    var disposition = headers.getResponseHeader('content-disposition');
                    var matches = /"([^"]*)"/.exec(disposition);
                    var filename = (matches != null && matches[1] ? matches[1] : fileName + '.' + extension);

                    var byteArray = new Uint8Array(data);
                    var blob = new Blob([byteArray], {type: headers});
                    saveAs(blob, filename);

                    showNotification('Document is aangemaakt', '', 'success');
                    stopLadda()
                },
                error: function (data, status, headers) {
                    stopLadda()
                    showNotification('Er is iets fout gegaan. Neem contact op met de beheerder', '', 'error');
                }
            });
        })
    }
}

